import React, {useState, useRef, useEffect} from "react";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import ReactQuill from "react-quill";
import {Fieldset} from "primereact/fieldset";
import {Card} from 'primereact/card';
import {Panel} from 'primereact/panel';
import Spinner from '../../spinner/Spinner'
import axios from "axios";
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from 'primereact/inputnumber';
import {Menubar} from 'primereact/menubar';


function MyEditor() {


}

MyEditor.modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        [{'header': 1}, {'header': 2}],               // custom button values
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
        [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
        [{'direction': 'rtl'}],                         // text direction

        [{'size': ['small', false, 'large', 'huge']}],
        ["link"], // dropdown with defaults from theme
        [{'font': []}],
        [{'align': []}],

        [{'color': []}, {'background': []}],
        ['clean'],


    ]
};

MyEditor.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "code-block",

];


const CmsPage = props => {
    const toast = useRef(null);

    const [menuSequence, setMenuSequence] = useState(null);
    const [pageID, setPageID] = useState(null);
    const [pageTitle, setPageTitle] = useState('');
    const [pageText, setPageText] = useState('');
    const page_add_role = localStorage.getItem('intropage_add') ? true : false;
    const [loadingState, setLoadingState] = useState(false)
    const [moduleList, setModuleList] = useState([]);
    const [modulID, setModulID] = useState('');


    useEffect(() => {
            getModuleList();
        }
        ,
        []
    );
    const getModuleList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content/module/list/', {"headers": headers})
            .then(res => {

                setModuleList(res.data)
            })
    }
    const ModuleOptionItems = moduleList.map((item) => (
        {"label": item.md_name, "value": item.md_id}
    ))


    const handleBody = e => {
        setPageText(e);
    };

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const submit = () => {
        const obj = {
            pageID: pageID,
            pageTitle: pageTitle,
            pageText: pageText,

        };

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            if (pageID) {
                fetch("/api/page_add" + "/" + pageID + "/", {headers, method: "PUT", body})
                    .then(res => {
                        if (res.status < 500) {
                            setLoadingState(false)
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            setLoadingState(false)
                            const data = res.data;

                            if (data.result) {
                                window.location.hash = '/pages'

                                showSuccess(data.message);
                            } else {
                                showError(data.message);
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            setLoadingState(false);
                            throw res.data;

                        } else if (res.status === 403) {
                            setLoadingState(false);
                            throw res.data;

                        }
                    })
            } else {
                headers["Authorization"] = `Token ${token}`;
                const body = JSON.stringify(obj);
                fetch("/api/page_add/", {headers, method: "POST", body})
                    .then(res => {
                        if (res.status < 500) {
                            setLoadingState(false)
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            setLoadingState(false)
                            const data = res.data;
                            if (data.result) {
                                window.location.hash = '/pages'

                                showSuccess(data.message);
                                // setData(data.result)
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            setLoadingState(false);
                            throw res.data;

                        } else if (res.status === 403) {
                            setLoadingState(false);
                            throw res.data;

                        }
                    })


            }
        }

        setPageText('')
        setPageTitle('')


    }
    const nestedMenuitems = [
        {
            label: 'Customers',
            icon: 'pi pi-fw pi-table',
            items: [
                {
                    label: 'New',
                    icon: 'pi pi-fw pi-user-plus',
                    items: [
                        {
                            label: 'Customer',
                            icon: 'pi pi-fw pi-plus'
                        },
                        {
                            label: 'Duplicate',
                            icon: 'pi pi-fw pi-copy'
                        },

                    ]
                },
                {
                    label: 'Edit',
                    icon: 'pi pi-fw pi-user-edit'
                }
            ]
        },
        {
            label: 'Orders',
            icon: 'pi pi-fw pi-shopping-cart',
            items: [
                {
                    label: 'View',
                    icon: 'pi pi-fw pi-list'
                },
                {
                    label: 'Search',
                    icon: 'pi pi-fw pi-search'
                },

            ]
        },
        {
            label: 'Shipments',
            icon: 'pi pi-fw pi-envelope',
            items: [
                {
                    label: 'Tracker',
                    icon: 'pi pi-fw pi-compass'

                },
                {
                    label: 'Map',
                    icon: 'pi pi-fw pi-map-marker'

                },
                {
                    label: 'Manage',
                    icon: 'pi pi-fw pi-pencil'
                }
            ]
        },
        {
            label: 'Profile',
            icon: 'pi pi-fw pi-user',
            items: [
                {
                    label: 'Settings',
                    icon: 'pi pi-fw pi-cog'
                },
                {
                    label: 'Billing',
                    icon: 'pi pi-fw pi-file'
                }
            ]
        },
        {
            label: 'Quit',
            icon: 'pi pi-fw pi-sign-out'
        }
    ];
    const menubarEndTemplate = () => {
        return (
            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText type="text" placeholder="Search"/>
            </span>
        );
    };

    if (page_add_role) {

        return (
            <div className="p-fluid" style={{fontSize: 'large'}}>
                <Toast ref={toast}/>
                <Spinner loadingState={loadingState}/>

                <Panel>
                    <Card className="p-card-content">
                        <form onSubmit={submit}>

                            <div className="p-grid">
                                <div className="p-col-10 p-md-offset-1" align="center">
                                    <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">
                                        <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">


                                            <Fieldset legend="Menü Bilgilerini Giriniz" toggleable>


                                                <div className="p-col-12 p-md-12" align="left">
                                                    <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">

                                                        <Dropdown
                                                            options={ModuleOptionItems}
                                                            onChange={(e) => setModulID(e.target.value)}
                                                            value={modulID}
                                                            filter={true}
                                                            showClear={true}
                                                            required={true}
                                                            placeholder="Modül Seçiniz"

                                                        />
                                                    </div>


                                                    <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">
                                                        <InputText
                                                            value={pageTitle}
                                                            onChange={(e) => setPageTitle(e.target.value)}
                                                            name="text"
                                                            id="text"
                                                            minLength={2}
                                                            maxLength={115}
                                                            required
                                                            placeholder="Menü İsmi Ekle"

                                                            className="p-inputtext-lg p-d-block"
                                                        />
                                                    </div>
                                                    <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">
                                                        <InputNumber inputId="integeronly" value={menuSequence}
                                                                     placeholder="Menü Sırası Seçiniz"
                                                                     onValueChange={(e) => setMenuSequence(e.value)}
                                                                     min={0} max={10}/>

                                                    </div>

                                                </div>

                                            </Fieldset>


                                        </div>


                                    </div>


                                    <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">
                                        <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">


                                            <Fieldset legend="Sayfa Bilgilerini Giriniz" toggleable>

                                                <div className="p-col-12 p-md-12" align="left">


                                                    <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">
                                                        <InputText
                                                            value={pageTitle}
                                                            onChange={(e) => setPageTitle(e.target.value)}
                                                            name="text"
                                                            id="text"
                                                            minLength={2}
                                                            maxLength={115}
                                                            required
                                                            placeholder="Başlık Ekle"

                                                            className="p-inputtext-lg p-d-block"
                                                        />
                                                    </div>
                                                    <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3">


                                                        <ReactQuill

                                                            placeholder="Birşeyler yaz"
                                                            modules={MyEditor.modules}
                                                            formats={MyEditor.formats}
                                                            onChange={handleBody}
                                                            value={pageText}
                                                            style={{
                                                                maxHeight: '600px',
                                                                overflowY: 'scroll',
                                                                overflowX: 'block'
                                                            }}

                                                        >

                                                        </ReactQuill>


                                                    </div>
                                                </div>

                                            </Fieldset>


                                        </div>


                                    </div>


                                </div>


                            </div>
                            <div className="p-m-1 p-p-1 p-m-lg-3 p-b-lg-3" align="center">


                                <Button label="Ekle" icon="pi pi-check" className="p-button-secondary"
                                        onClick={submit}
                                        style={{height: '40px', width: '15%'}}/>
                            </div>
                        </form>
                    </Card>

                </Panel>
            </div>
        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}

export default CmsPage;



// WEBPACK FOOTER //
// ./src/pages/cmsmanagement/CmsPage.jsx